module.exports = __webpack_public_path__ + "img/lumen.4b461ce1.jpg";